export default "__VITE_ASSET__2717b508__"